import { CommonModule } from '@angular/common';
import { BarChartModule } from 'ChartApp/ts/features/bar-chart/bar-chart.module';
import { FactorCoefficientRangeModule } from 'ChartApp/ts/features/factor-coefficient-range/factor-coefficient-range.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { ScatterPlotModule } from 'ChartApp/ts/features/scatter-plot/scatter-plot.module';
import { SingleDatePickerModule } from 'NewAngular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { RadioButtonGroupModule } from 'NewAngular/features/components/inputs/radio-button-group/radio-button-group.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { LoadingModalModule } from 'NewAngular/features/components/modals/loading-modal/loading-modal.module';
import { PdfTitleModalModule } from 'NewAngular/features/components/pdf-title-modal/pdf-title-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class AttributionFactorAnalysisModule {
}
AttributionFactorAnalysisModule.ɵfac = function AttributionFactorAnalysisModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionFactorAnalysisModule)(); };
AttributionFactorAnalysisModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AttributionFactorAnalysisModule });
AttributionFactorAnalysisModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AutocompleteInPlaceModule,
        BarChartModule,
        FactorCoefficientRangeModule,
        CommonModule,
        DisabledModule,
        GeneralChartModule,
        HelpModalModule,
        IconModule,
        LoadingModalModule,
        LoadingSymbolModule,
        ModuleUpsellModule,
        PdfTitleModalModule,
        RadioButtonGroupModule,
        ScatterPlotModule,
        SingleDatePickerModule,
        SingleSelectDropdownModule,
        TooltipModule] });
